angular.module('pitch.playlist.pitch', [
    //this uses pitch.app - and pitch.app uses this - is this correct. For now it seems to work?
    //@todo Move some shared functionality in core module.
    'pitch.app',
    'satv.playlist.pitch',
    'ui.router'
])

.config(function($stateProvider, config) {
    "use strict";
    //template helper
    function tpl(t) {
        return config.templateRoot + '/' + t + '?version=' + config.app_release_id;
    }

    $stateProvider
        .state('pitchLanding', {
            url: "/playlists/pitch/{hash}",
            templateUrl: tpl('templates/playlists/pitch-landing'),
            controller: 'PitchPitchLandingCtrl',
            parent: 'root',
            resolve: {
                pitch: function($stateParams, SinglePitchLoader) {
                    return SinglePitchLoader({
                        hash: $stateParams.hash.substring(0, 32)
                    });
                }
            }
        })
    ;
})

;



// WEBPACK FOOTER //
// ./src/PlaylistPitchClientBundle/Resources/js/angular/app.js